
export function listenTo(event, callback) {
    window.addEventListener(event, callback);
}

export function fire(event, data) {
    window.dispatchEvent(new CustomEvent(event, {
        detail: data
    }))
}